<template>
  <div class="ProductPrice Recap">
    <div v-if="hasPromo" class="ProductPrice-infoPrice">
      <p class="priceBig" :inner-html.prop="specialPrice | formatPrice(2)"></p>
      <div class="priceOriginal" v-if="originalPrice">
        <p :inner-html.prop="originalPrice | formatPrice(2)"></p>
      </div>
    </div>

    <div v-else class="ProductPrice-infoPrice">
      <p class="priceBig" :inner-html.prop="originalPrice | formatPrice(2)"></p>
    </div>
  </div>
</template>

<script>
import PriceMixin from "@/mixins/priceMixin";
import "@/includes/Product/ProductPrice/ProductPrice.scss";

export default {
  name: "ProductPrice",
  mixins: [PriceMixin],
  props: {
    originalPrice: { String, Number },
    specialPrice: { String, Number },
  },
};
</script>
